import { cva, VariantProps } from "class-variance-authority";

export const tabsVariants = cva(["relative flex"], {
  variants: {
    variant: {
      default: ["border-b border-balticSea/20 gap-x-3"],
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

export type TabsVariantsProps = VariantProps<typeof tabsVariants>;

export const tabVariants = cva(
  [
    "relative inline-flex justify-center cursor-pointer items-center outline-hidden transition whitespace-nowrap",
  ],
  {
    variants: {
      variant: {
        default: [
          "text-balticSea font-medium text-sm leading-5 pb-3 transition",
        ],
      },
      isActive: {
        false: null,
        true: null,
      },
    },

    compoundVariants: [
      { variant: "default", isActive: true, className: "text-persianOrange" },
    ],

    defaultVariants: {
      variant: "default",
    },
  }
);

export type TabVariantsProps = VariantProps<typeof tabVariants>;
